import React from "react";
import { FilterComponent } from "./";
import { buildTableValues } from "../../utils/customization/filter";

// prettier-ignore
const R_COEFS = [
  -23.608, 104.043, -183.437, 160.956, -68.572, 8.814, 3.153, -2.039, 0.154, 1.535, 0
];
// prettier-ignore
const ALL_COEFS = [
  6.847, -43.126, 113.394, -161.887, 135.986, -67.902, 19.814, -3.667, 0.264, 1.277, 0
];

let tableValues:
  | {
      r: string;
      gb: string;
    }
  | undefined;

const Redmug: FilterComponent = ({ id, height, width }) => {
  if (!tableValues) {
    tableValues = {
      gb: buildTableValues(ALL_COEFS),
      r: buildTableValues(R_COEFS, ALL_COEFS),
    };
  }

  return (
    <filter
      colorInterpolationFilters="sRGB"
      filterUnits="objectBoundingBox"
      height={height}
      id={id}
      width={width}
      x={0}
      y={0}
    >
      <feComponentTransfer in="SourceGraphic">
        <feFuncR tableValues={tableValues.r} type="table" />
        <feFuncG tableValues={tableValues.gb} type="table" />
        <feFuncB tableValues={tableValues.gb} type="table" />
        <feFuncA type="identity" />
      </feComponentTransfer>
    </filter>
  );
};

export default Redmug;
